var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import "../styles/Support.css";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Notification from "../../App/components/Notification";
import { useForm } from "react-hook-form";
import CustomerService from "../../Customer/services/CustomerService";
import InfoIcon from "@mui/icons-material/Info";
function Support() {
    var _a = useForm(), register = _a.register, handleSubmit = _a.handleSubmit;
    var _b = useState(""), searchingTerm = _b[0], setSearchingTerm = _b[1];
    var _c = useState([]), customers = _c[0], setCustomers = _c[1];
    var _d = useState(false), displayTable = _d[0], setDisplayTable = _d[1];
    var handleFilterText = function (event) {
        setSearchingTerm(event.target.value);
    };
    var BLOCKED_CUSTOMER_IDS = [8];
    var BLOCKED_NAME_TERMS = ["celeti", "supercomm"];
    function isBlockedCustomer(customer) {
        var _a, _b;
        var name = (_b = (_a = customer.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        return (BLOCKED_CUSTOMER_IDS.includes(customer.id) ||
            BLOCKED_NAME_TERMS.some(function (term) { return name.includes(term); }));
    }
    function handleSearch(_providersSearch) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setDisplayTable(true);
                Notification().Block.dots("[data-id=providers-grid]");
                CustomerService.searchSupport(searchingTerm).then(function (res) {
                    var _a;
                    setSearchingTerm(searchingTerm);
                    var filteredCustomers = ((_a = res.data.customers) !== null && _a !== void 0 ? _a : []).filter(function (customer) { return !isBlockedCustomer(customer); });
                    setCustomers(filteredCustomers);
                    Notification().Block.remove("[data-id=providers-grid]");
                }, function (err) {
                    Notification().Notify.failure(err.message);
                    Notification().Block.remove("[data-id=providers-grid]");
                });
                return [2 /*return*/];
            });
        });
    }
    return (_jsxs("div", { children: [_jsx("header", __assign({ className: "support-header" }, { children: _jsx("h1", __assign({ className: "support-title" }, { children: "Est\u00E1 com Problemas?" })) })), _jsxs("section", __assign({ className: "support-description" }, { children: [_jsx("p", { children: "Para tirar suas d\u00FAvidas, e resolver quaisquer problemas relacionados a sua assinatura, entre em contato com o seu provedor de internet. Abaixo voc\u00EA pode buscar pelo nome do seu provedor para encontrar o n\u00FAmero do contato de suporte." }), _jsxs("form", __assign({ className: "support-search-form", onSubmit: handleSubmit(handleSearch) }, { children: [_jsxs("div", __assign({ className: "box-text-search" }, { children: [_jsx(SearchRoundedIcon, { style: { color: "#2160B5" } }), _jsx("input", __assign({}, register("term"), { type: "text", placeholder: "Digite o nome do provedor", value: searchingTerm, onChange: handleFilterText, required: true, minLength: 3, className: "search-input" }))] })), _jsx("button", __assign({ type: "submit", className: "button-search-providers" }, { children: "Buscar" }))] })), displayTable && customers !== undefined && (_jsx("div", __assign({ className: "box-result-search-providers", "data-id": "providers-grid" }, { children: customers && customers.length > 0 ? (_jsxs("table", __assign({ className: "table" }, { children: [_jsx("thead", { children: _jsxs("tr", __assign({ className: "table-header", style: { textAlign: "center" } }, { children: [_jsx("th", { children: "Nome" }), _jsx("th", { children: "Telefone de Suporte" }), _jsx("th", { children: "Email de Suporte" }), _jsx("th", { children: "WhatsApp de Suporte" })] })) }), _jsx("tbody", __assign({ style: { textAlign: "center" } }, { children: customers.map(function (customer, index) { return (_jsxs("tr", __assign({ id: "box-result-isp" }, { children: [_jsx("td", { children: customer.name }), _jsx("td", { children: customer.support_phone }), _jsx("td", { children: customer.support_mail }), _jsx("td", { children: customer.support_whatsapp })] }), index)); }) }))] }))) : (_jsxs("div", __assign({ id: "text-result-not-found" }, { children: [_jsx(InfoIcon, { style: { width: "1.3rem" } }), _jsx("p", { children: "Nenhum resultado encontrado." })] }))) })))] }))] }));
}
export default Support;
